var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaymentReceived = function SvgPaymentReceived(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 14.0498V22.2498",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 20.8837H16.7833C16.7833 20.1587 16.4954 19.4635 15.9828 18.9509C15.4702 18.4383 14.7749 18.1503 14.05 18.1503H10.6333C10.6333 17.4254 10.3454 16.7302 9.83276 16.2176C9.32016 15.705 8.62492 15.417 7.9 15.417H1.75",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2168 18.1504H10.6335",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1501 4.4834H16.2978C16.0139 4.4836 15.739 4.58256 15.5201 4.76332C15.3012 4.94408 15.152 5.19537 15.0981 5.47408C15.0443 5.7528 15.0891 6.04158 15.2248 6.29088C15.3606 6.54018 15.5789 6.73448 15.8422 6.84044L17.7228 7.59302C17.9861 7.69898 18.2044 7.89328 18.3402 8.14258C18.4759 8.39189 18.5207 8.68066 18.4668 8.95938C18.413 9.23809 18.2638 9.48938 18.0449 9.67014C17.826 9.8509 17.5511 9.94987 17.2672 9.95006H15.4167",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7832 4.48314V3.7998",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7832 10.6335V9.9502",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3167 7.21667C11.3167 8.66652 11.8926 10.057 12.9178 11.0822C13.943 12.1074 15.3335 12.6833 16.7833 12.6833C18.2332 12.6833 19.6236 12.1074 20.6488 11.0822C21.674 10.057 22.25 8.66652 22.25 7.21667C22.25 5.76682 21.674 4.37635 20.6488 3.35115C19.6236 2.32595 18.2332 1.75 16.7833 1.75C15.3335 1.75 13.943 2.32595 12.9178 3.35115C11.8926 4.37635 11.3167 5.76682 11.3167 7.21667V7.21667Z",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentReceived, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment-received.6c014abe.svg";
export { ForwardRef as ReactComponent };